import { Component } from '@angular/core';

@Component({
  selector: 'app-ivy-face',
  standalone: true,
  imports: [],
  templateUrl: './ivy-face.component.html',
  styleUrl: './ivy-face.component.scss'
})
export class IvyFaceComponent {

}
